<template>
  <vx-card no-shadow>
    <div id="editClubLoadingDiv" class="vs-con-loading__container">

      <div class="vx-row">
        <div class="vx-col sm:w-full w-full mb-5">
          <vs-input v-validate="'required|alpha_spaces'" name="club_name" ref="club_name" class="w-full" label-placeholder="Club Name" v-model="clubData.club_name"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('club_name')">{{ errors.first('club_name') }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-full w-full mb-5">
          <vs-input v-validate="'required|email'" name="club_email" ref="club_email" class="w-full" label-placeholder="Club Email" v-model="clubData.club_email"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('club_email')">{{ errors.first('club_email') }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-full w-full mb-5">
          <vs-input v-validate="'required|numeric|digits:8'" name="club_phone" ref="club_phone" class="w-full" label-placeholder="Club Phone" v-model="clubData.club_phone"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('club_phone')">{{ errors.first('club_phone') }}</span>
        </div>
      </div>

      <div class="vx-row">
        <div class="vx-col sm:w-full w-full mb-5">
          <vs-input v-validate="'required|numeric|digits:8'" name="cvr_number" ref="cvr_number" class="w-full" label-placeholder="Club CVR Number" v-model="clubData.cvr_number"></vs-input>
          <span class="text-danger text-sm" v-show="errors.has('cvr_number')">{{ errors.first('cvr_number') }}</span>
        </div>
      </div>

      <vs-textarea label="Club Description" v-model="clubData.description" placeholder="Club Description..." />

      <!-- Save & Reset Button -->
      <div class="flex flex-wrap items-center justify-end">
        <vs-button @click="resetClubData" class="ml-4 mt-2" type="border" color="warning">Reset</vs-button>
        <vs-button @click="validateClubData" class="ml-4 mt-2">Save Changes</vs-button>
      </div>
    </div>
  </vx-card>
</template>

<script>
import moduleClubManagement from '@/store/club-management/moduleClubManagement.js'

export default {
  components: {

  },
  data() {
    return {
      clubData : JSON.parse(localStorage.getItem("clubData")),
      clubOriginalData : JSON.parse(localStorage.getItem("clubData")),
    }
  },
  computed: {
    // clubData() {
    //   return this.$store.state.clubManagement.club
    // },
  },
  methods: {
    resetClubData() {
      this.clubData = JSON.parse(localStorage.getItem("clubData"))
    },
    validateClubData() {
      this.$validator.validateAll().then(result => {
        if (result) this.updateClubData()
      })
    },
    updateClubData() {
      var self = this
      
      this.$vs.loading({
        container: '#editClubLoadingDiv',
        scale: 0.6
      })

      let clubData = {
        club_name : this.clubData.club_name,
        club_email : this.clubData.club_email,
        club_phone : this.clubData.club_phone,
        cvr_number : this.clubData.cvr_number,
        description : this.clubData.description,
      }

      this.$store.dispatch("userManagement/updateClub", clubData)
        .then(res => { 
            this.$vs.loading.close('#editClubLoadingDiv > .con-vs-loading')

            this.$vs.notify({
                title: "Success.",
                text: "Club updated successfully.",
                iconPack: "feather",
                icon: "icon-alert-circle",
                color: "success"
            });
        })
        .catch(err => { 
          if(err.status && err.status == 422){
            Object.keys(err.data).forEach(function(key) {
              self.errors.add({
                field: key,
                msg: err.data[key][0],
              });
            });
          }

          this.$vs.loading.close('#editClubLoadingDiv > .con-vs-loading')
        })

    },
    getClubData() {
      this.$store.dispatch("clubManagement/getClubData")
        .then(res => { 
          this.clubData = res.data
          this.clubOriginalData = res.data
        })
        .catch(err => { })
    },
  },
  created() {
    if(!moduleClubManagement.isRegistered) {
        this.$store.registerModule('clubManagement', moduleClubManagement)
        moduleClubManagement.isRegistered = true
    }

    this.getClubData()
  },
}
</script>
